import React from "react";
import { casesActions } from "configs";
import { UpdateCardProps, useCurrentCase, useDispatch } from "duck";
import {
  useDeleteDefibMedicationsMutation,
  useUpdateDefibMedicationMutation
} from "requests";

export const useDeleteDefib = () => {
  const dispatch = useDispatch();
  const [deleteMedication] = useDeleteDefibMedicationsMutation({
    ignoreResults: true
  });
  const { shouldSync, caseId } = useCurrentCase(medicalCase => ({
    shouldSync: medicalCase.shouldSync,
    caseId: medicalCase.data._id
  }));

  return (ids: (number | string)[]) => {
    if (shouldSync) {
      const filteredIds = ids.filter(id => !Number.isNaN(id));
      return deleteMedication({
        variables: { input: { ids: filteredIds as number[] } }
      }).then(() => {
        dispatch(
          casesActions.deleteDefibMedications({ data: ids, _id: caseId })
        );
      });
    }

    dispatch(casesActions.deleteDefibMedications({ data: ids, _id: caseId }));
  };
};

export const useUpdateDefib = () => {
  const [update] = useUpdateDefibMedicationMutation({ ignoreResults: true });
  const dispatch = useDispatch();
  const { shouldSync, caseId } = useCurrentCase(medicalCase => ({
    shouldSync: medicalCase.shouldSync,
    caseId: medicalCase.data._id
  }));

  return React.useCallback(
    (values: UpdateCardProps) => {
      const { idOrFakeId, ...data } = values;

      if (shouldSync) {
        dispatch(
          casesActions.updateDefibMedication({
            data: {
              ...(typeof idOrFakeId === "number"
                ? { _id: idOrFakeId }
                : { fakeId: idOrFakeId }),
              ...data
            },
            _id: caseId
          })
        );

        if (typeof idOrFakeId === "number") {
          return update({ variables: { input: { _id: idOrFakeId, ...data } } });
        }
      }

      dispatch(
        casesActions.updateDefibMedication({
          _id: caseId,
          data: {
            ...(typeof idOrFakeId === "number"
              ? { _id: idOrFakeId }
              : { fakeId: idOrFakeId }),
            ...data
          }
        })
      );
    },
    [update, shouldSync]
  );
};
